<script setup lang="ts">
import { Icon, IconName } from '@exfluential/ui';
import { useSearchReturn } from '~/composables/use-search-return';

const { searchQuery, resultsCount, returnUrl } = useSearchReturn();
</script>

<template>
  <NuxtLink
    v-if="returnUrl && searchQuery"
    :to="returnUrl"
    class="inline-flex items-center gap-2 rounded-full bg-on-surface px-4 py-2 text-sm font-medium text-surface"
  >
    <Icon :name="IconName.CHEVRON_LEFT" class="h-4 w-4" />
    <span>{{ $t('search.return-pill', { query: searchQuery }) }}</span>
    <template v-if="resultsCount">
      <span aria-hidden="true">•</span>
      <span>
        {{ $t('search.return-pill-count', { count: resultsCount }) }}
      </span>
    </template>
  </NuxtLink>
</template>
